import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from './../../common/Pagination';
import { findPermission } from './../../../utils';
import numeral from 'numeral';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

class Table extends Component {
    static propTypes = {
        elements: PropTypes.array,
        handleSort: PropTypes.func,
        handleUpdateFormValue: PropTypes.func,
        isFetchingElements: PropTypes.bool,
        handleShowForm: PropTypes.func,
        handleShowDelete: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        handleViewProperty: PropTypes.func,
        handleChangeFilter: PropTypes.func,
        user: PropTypes.object,
        filterFields: PropTypes.object
    };

    renderTableHeader(label, name, style, sortable = true) {
        const { handleSort, sortColumn, sortType } = this.props;

        let icon = <i className="fas fa-sort" />;
        if (sortColumn === name) {
            if (sortType === 'asc') {
                icon = <i className="fas fa-sort-up" />;
            } else {
                icon = <i className="fas fa-sort-down" />;
            }
        }

        if (sortable) {
            return <th style={style}><span onClick={handleSort.bind(this, name)}>{label} {icon}</span></th>;
        }

        return <th style={style}>{label}</th>;
    }

    renderData() {
        const { elements, isFetchingElements, handleShowForm, handleShowDelete, user } = this.props;

        if (isFetchingElements) {
            return (
                <tr>
                    <td colSpan="17"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (elements.length === 0) {
            return (
                <tr>
                    <td colSpan="17">No Results</td>
                </tr>
            );
        }

        let permission = null;
        if (user) {
            permission = findPermission(user['permissions'], 'Landry\'s');
        }

        let data = [];
        for (let i = 0; i < elements.length; i++) {
            let editAction = null;
            if (permission != null && permission['Edit']) {
                editAction = (
                    <Tooltip title="Edit" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="fas fa-edit" onClick={handleShowForm.bind(this, elements[i].id, null)} />
                    </Tooltip>
                );
            }

            let deleteAction = null;
            if (permission != null && permission['Delete']) {
                deleteAction = (
                    <Tooltip title="Delete" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="fas fa-trash" onClick={handleShowDelete.bind(this, elements[i].id)} />
                    </Tooltip>
                );
            }

            data.push(
                <tr key={i}>
                    <td>{moment(elements[i]['date']).format('MM/DD/YYYY')}</td>
                    <td>{elements[i]['description']}</td>
                    <td>{elements[i]['invoice_size_name']}</td>
                    <td>{elements[i]['invoice_stock_name']}</td>
                    <td>{elements[i]['ink_name']}</td>
                    <td>{elements[i]['invoice_machine_name']}</td>
                    <td>{numeral(elements[i]['quantity']).format('0,0')}</td>
                    <td>{numeral(elements[i]['landrys']).format('$0,0.00')}</td>
                    <td>{numeral(elements[i]['per_unit']).format('$0,0.00')}</td>
                    <td>{numeral(elements[i]['larry']).format('$0,0.00')}</td>
                    <td>{numeral(elements[i]['larry_per_unit']).format('$0,0.00')}</td>
                    <td>{numeral(elements[i]['ac']).format('$0,0.00')}</td>
                    <td>{numeral(elements[i]['ac_per_unit']).format('$0,0.00')}</td>
                    <td>{numeral(elements[i]['robert']).format('$0,0.00')}</td>
                    <td>{elements[i]['ps']}</td>
                    <td>{elements[i]['pm']}</td>
                    <td>
                        <div className="actions">
                            {editAction}
                            {deleteAction}
                        </div>
                    </td>
                </tr>
            );
        }

        return data;
    }

    handleKey(name, event) {
        const { handleChangeFilter } = this.props;
        if (event.key === 'Enter') {
            handleChangeFilter(name, event);
        }
    }

    renderSearchField(name) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <input type="text" name={name} className="search-input" onBlur={handleChangeFilter.bind(this, name)} onKeyPress={this.handleKey.bind(this, name)} />
            </th>
        );
    }

    renderSearchSelect(name, options) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <select type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} >
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option['value']}>{option['label']}</option>
                        );
                    })}
                </select>
            </th>
        );
    }

    render() {
        const { totalPages, selectedPage, totalItems, handleChangeFilter, handleSetActivePage, landrys, larry, ac, robert } = this.props;
        return (
            <div id="tables-container" className="production-container">
                <div className="table-container table-hover">
                    <table id="titles-table" className="table table-sm table-hover">
                        <thead>
                            <tr>
                                {this.renderTableHeader('Date', 'date', { width: 162 })}
                                {this.renderTableHeader('Description', 'description')}
                                {this.renderTableHeader('Size', 'invoice_size_name', { width: 100 })}
                                {this.renderTableHeader('Stock', 'invoice_stock_name')}
                                {this.renderTableHeader('Ink', 'ink_name', { width: 90 })}
                                {this.renderTableHeader('Machine', 'invoice_machine_name')}
                                {this.renderTableHeader('Quantity', 'quantity', { width: 90 })}
                                {this.renderTableHeader('Landry\'s', 'landrys', { width: 90 })}
                                {this.renderTableHeader('Landry\'s/Unit', 'per_unit', { width: 110 }, false)}
                                {this.renderTableHeader('Larry', 'larry', { width: 90 })}
                                {this.renderTableHeader('Larry/Unit', 'larry_per_unit', { width: 110 }, false)}
                                {this.renderTableHeader('AC', 'ac', { width: 90 })}
                                {this.renderTableHeader('AC/Unit', 'ac_per_unit', { width: 110 }, false)}
                                {this.renderTableHeader('Robert', 'robert', { width: 90 })}
                                {this.renderTableHeader('PS #', 'ps', { width: 90 })}
                                {this.renderTableHeader('PM #', 'pm', { width: 90 })}
                                <th style={{ width: 80 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th className="search-th multiple-date">
                                    <DayPickerInput
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        placeholder=""
                                        format="MM/DD/YY"
                                        onDayChange={handleChangeFilter.bind(this, 'start_date')}
                                    />
                                    <div className="float-left ml-1 mr-1">to</div>
                                    <DayPickerInput
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        placeholder=""
                                        format="MM/DD/YY"
                                        onDayChange={handleChangeFilter.bind(this, 'end_date')}
                                    />
                                </th>
                                {this.renderSearchField('description')}
                                {this.renderSearchField('invoice_size_name')}
                                {this.renderSearchField('invoice_stock_name')}
                                {this.renderSearchSelect('ink_name', [
                                    { label: '', value: '' },
                                    { label: '4/0', value: '4/0' },
                                    { label: '4/1', value: '4/1' },
                                    { label: '4/4', value: '4/4' },
                                    { label: '1/1', value: '1/1' },
                                    { label: '1/0', value: '1/0' },
                                    { label: '2/0', value: '2/0' },
                                    { label: '5/5', value: '5/5' }
                                ])}
                                {this.renderSearchField('invoice_machine_name')}
                                <th></th>
                                <th style={{ fontWeight: 'bold', color: '#388e3c' }}>{numeral(landrys).format('$0,0.00')}</th>
                                <th></th>
                                <th style={{ fontWeight: 'bold', color: '#388e3c' }}>{numeral(larry).format('$0,0.00')}</th>
                                <th></th>
                                <th style={{ fontWeight: 'bold', color: '#388e3c' }}>{numeral(ac).format('$0,0.00')}</th>
                                <th></th>
                                <th style={{ fontWeight: 'bold', color: '#388e3c' }}>{numeral(robert).format('$0,0.00')}</th>
                                {this.renderSearchField('ps')}
                                {this.renderSearchField('pm')}
                                <th className="search-th"></th>
                            </tr>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <Pagination.Container
                        totalItems={totalItems}
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        elementsPerPage={20}
                        handleSetActivePage={handleSetActivePage}
                    />
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default Table;
